import { useTranslation } from 'react-i18next';

type ptxProps = {
  ptx: string;
};
// pt01: string; // 충전
// pt02: string; // 결제
// pt03: string; // 포인트 이체
// pt04: string; // 포인트 환불
// pt06: string; // 암호화폐 전환
// pt07: string; // 포인트 충전 취소
// pt08: string; // 포인트 결제 취소
// pt09: string; // 리워드 결제
// pt10: string; // 리워드 결제 취소
// pt12: string; // 리워드 지급
// pt13: string; // 리워드 적립
// pt14: string; // 리워드 소멸
// pt15: string; // 리워드 취소
// pt16: string; // 리워드 적립 예정
// pt17: string; // 리워드 전환

export default function PtxType({ ptx }: ptxProps) {
  const { t } = useTranslation();
  return <>{t(`ptx.${ptx}`)}</>;
}
